import {observer} from "mobx-react";
import _ from "lodash";
import React, {useState, useEffect} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {callWithCatch, matchFormat, pp, tourneyUrl} from "../../utils";
import {
    Affix,
    Button,
    Card,
    Dropdown,
    Form,
    Input,
    Menu,
    message,
    Modal,
    notification, Radio,
    Select,
    Skeleton,
    Space
} from "antd";
import FakeTable from "../../components/FakeTable";
import XhrBtn from "../../components/XhrBtn";
import axios from "axios";
import NiceModal from "@ebay/nice-modal-react";
import PoolsSelector from "../tournament/PoolsSelector";
import FractionProgress from "../../components/FractionProgress";
import {LoaderDrawer, ModalBtn, NiceModalForm} from "../../components/Modals";
import Leaderboard, {PlayoffBracket} from "../tournament/Leaderboard";
import {Showable, Switch2} from "../../components/Switcher";
import User from "../../components/User";
import {observable} from "mobx";
import Stats from "../exclusive_tt/Stats";
import StatusTag from "../../components/StatusTag";
import Device from "../../components/Device";
import Spacer from "../../components/Spacer";
import DivisionRanking from "../tournament/DivisionRanking";
import PrelimsLeaderboard from "../tournament/PrelimsLeaderboard";
import GenPlayoff from "../tourney/GenPlayoff";
import FormSelector from "../../components/FormSelector";
import ScoreTag from "@/components/ScoreTag.js";
import ScoreBtn from "@/components/ScoreBtn.js";
import PlayersCheckinStatus from "@/apps/tourney/PlayersCheckinStatus.js";
import {DownOutlined} from "@ant-design/icons";
import WithTitle from "../tourney/WithTitle";
import TeamsGroupsChooser from "../../components/TeamsGroupsChooser";
import Tourney from "@/apps/tourney/Tourney.js";
import mainStore from "@/apps/tourney/store.js";
import MatchEditor, { TeamName } from "../../components/MatchEditor";

let Print = observer(({id, types}) => {
    if (!gon.tournament.printer)
        return null;

    let onClick = (e) => {
        window.open("/pools/" + id + "/pdf?type=" + e.key, "_blank")
    }
    const menu = (
        <Menu
            onClick={onClick}
            items={types.map(t => ({
                label: t[1],
                key: t[0],
            }))}
        />
    );

    return <Dropdown overlay={menu} trigger={['click']}>
        <Button>
            <Space>
                Print
                <DownOutlined />
            </Space>
        </Button>
    </Dropdown>
});

let PoolPrint = ({id}) => {
    let types = [
        ["han_overview", "Overview"],
        [false ? "han_full_scorecards" : "han_half_scorecards", "Scorecards"],
        ["han_half_ref_scorecards", "Refs Scorecards"],
    ];

    if (Tourney.hop_tryouts)
        types = [
            ["han_overview", "Overview"],
        ];

    return <Print id={id} types={types} />
}

let CustomPrint = NiceModal.create(({ d }) => {
    let teams = _.sortBy(d.teams, 'name');

    let onSave = ({t1_id, t2_id}) => {
        window.open(`/divisions/${d.id}/pdf?t1_id=${t1_id}&t2_id=${t2_id}`, "_blank");
        NiceModal.remove(CustomPrint);
    }

    return <NiceModalForm onSave={onSave}
                          title="Custom Scorecard"
                          width={300}
                          okText="Print"
                          vertical
                          initialValues={{ t1_id: teams[0].id, t2_id: teams[1].id}}>
        <FormSelector width="250px" name="t1_id" label="Team1" options={teams.map(pl => [pl.id, pl.name])} />
        <FormSelector width="250px" name="t2_id" label="Team2" options={teams.map(pl => [pl.id, pl.name])} />
    </NiceModalForm>
});

let CreateStageModal = NiceModal.create(({ d, onReload }) => {
    const [teamsGroups, setTeamsGroups] = useState({
        teams: d.teams.map(team => ({ ...team, group_id: 1 })),
        groups: [{ id: 1, name: "Pool 1" }]
    });

    const addGroup = () => {
        // Find the last group name, extract number, add 1
        const lastGroup = teamsGroups.groups[teamsGroups.groups.length - 1];
        const match = lastGroup.name.match(/(\d+)/);
        const lastNum = match ? parseInt(match[1]) : 1;
        const newName = lastGroup.name.replace(/\d+/, lastNum + 1);
        
        const newGroup = {
            id: Date.now(), // temporary ID
            name: newName,
        };
        const updatedGroups = [...teamsGroups.groups, newGroup];
        setTeamsGroups({
            ...teamsGroups,
            groups: updatedGroups
        });
    };

    let onSave = async (params) => {
        await callWithCatch({
            url: '/divisions/' + d.id,
            method: 'put',
            params: {
                ...params,
                gen_stage: true,
                stage: 0,
                teams: teamsGroups.teams,
                groups: teamsGroups.groups,
            },
            onSuccess: () => {
                message.success("Stage created!");
                NiceModal.remove(CreateStageModal);
                onReload();
            }
        });
    };

    return <NiceModalForm onSave={onSave}
                          title="Create Stage"
                          width={1200}
                          okText="Create Stage"
                          vertical>
        <Space>
            <Form.Item name="bracket_format" label="Style" rules={[{ required: true}]}>
                <Radio.Group optionType="button" buttonStyle="solid">
                    <Radio value="rr">RR</Radio>
                    <Radio value="dbl_rr">Double RR</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name="match_format" label="Format" rules={[{ required: true}]}>
                <Radio.Group optionType="button" buttonStyle="solid">
                    <Radio value="to_11">{matchFormat("to_11")}</Radio>
                    <Radio value="to_15">{matchFormat("to_15")}</Radio>
                    <Radio value="to_21">{matchFormat("to_21")}</Radio>
                    {/*<Radio value="best2of3_to_11">{matchFormat("best2of3_to_11")}</Radio>*/}
                </Radio.Group>
            </Form.Item>
        </Space>
        <TeamsGroupsChooser
            teams={teamsGroups.teams}
            groups={teamsGroups.groups}
            onChange={setTeamsGroups}
            addGroup={addGroup}
        />
    </NiceModalForm>
});


let AdminMatch = ({m, onUpdate}) => {
    let titleEl = <Space>
        <span>{m.name}</span>
        <span className="text-xs text-gray-500">(#{m.mid})</span>
    </Space>

    let edit = () => NiceModal.show(MatchEditor, { m: observable(_.cloneDeep(m)), onUpdate });

    let teamMini = i => {
        let t = m.teams[i];
        let r = m.results[i];

        return <Spacer key={t.id}>
            <TeamName t={t} />
            <ScoreTag v={r.points} type={r.type} />
        </Spacer>
    }

    let extra = <a className="hover-child" onClick={edit}>update scores</a>;

    return <Card className=" hover-parent cursor-pointer" onClick={edit} size="small" title={titleEl} extra={extra}>
        <div className="cursor-pointer" >
            <div key={m.id} className="space-y-2">
                {teamMini(0)}
                <hr/>
                {teamMini(1)}
            </div>
        </div>
    </Card>
}

let PoolDrawer = NiceModal.create(observer(({ d, dp }) => {
    const [store] = useState(() => observable({pool: null}));

    let ddp = store.pool;

    let load = data => store.pool = data.pool;

    let onUpdate = (reload_info) => {
        _.assign(d, reload_info.div);
        if (store.pool)
            store.pool = reload_info.pool;
    }

    let teamById = ddp ? _.keyBy(ddp.teams, 'id') : {}

    return <LoaderDrawer title={dp.name}
                         bodyStyle={{padding: 0}}
                         params={{
                             method: 'get',
                             onSuccess: load,
                             url: `/pools/${dp.id}`,
                         }}>
        <ErrorBoundary fallback={<div className="p-4 text-center">Error loading pool details</div>}>
            <div className="space-y-4 p-2">
                <div>
                    { User.admin && <PoolPrint id={dp.id} /> }
                </div>
                { ddp && <div className="space-y-4">
                    {ddp.trounds.map((r, ri) => <div key={r.id} className="p-2 space-y-4 bg-slate-100">
                        <div className="text-lg font-bold">{r.name}</div>
                        <div className="space-y-2">
                            {_.sortBy(r.matches, 'num').map(m => <AdminMatch m={m} key={m.id} onUpdate={onUpdate} />)}
                            {r.bye_ids.length > 0 && r.bye_ids.map(id => <Card key={id} size="small">
                                <div className="h-space">
                                    <div>{teamById[id].name}</div>
                                    <div>BYE</div>
                                </div>
                            </Card>)}
                        </div>
                    </div>)}
                </div> }
            </div>
        </ErrorBoundary>
    </LoaderDrawer>
}));

let statusFor = s => {
    if (s === "playing")
        return <StatusTag message="Playing" />;

    if (s === "done")
        return <StatusTag message="Done" type="success"/>;

    if (s === "checking_in")
        return <StatusTag message="Checking In"/>;
}

let AdminPool = observer(({d, dp}) => {
    let teamById = _.keyBy(d.teams, 'id');

    let actions = <Space>
        {dp.actions.map(a => {
            if (a === "print") {
                return <PoolPrint key="2" id={dp.id} />
            }

            if (a === "knockout")
                return <Button key="1" onClick={() => NiceModal.show(PlayoffBracket, { pool: dp })}>View Bracket</Button>

            if (a === "leaderboard") {
                return <ModalBtn key={a} footer={null} width={800} text="Leaderboard" style={{top: 20}}>
                    <Leaderboard division={dp} teamById={teamById}/>
                </ModalBtn>
            }

            if (a === "start") {
                let start = async () => {
                    let data = (await axios.post(`/pools/${dp.id}/start`)).data;
                    dp.status = "playing";
                    message.success("Started!");
                    window.location.reload() ;
                }

                return <XhrBtn key={a} onClick={start} type="primary">Start</XhrBtn>
            }

            if (a === "reset_playoff_round") {
                let recreate = async () => {
                    let content;
                    if (dp.rounds.length === 1)
                        content = "You'll then be able to recreate the whole playoff again";
                    else
                        content = `You'll then be able to recreate it again`;

                    let lastRound = dp.rounds[dp.rounds.length-1];

                    Modal.confirm({
                        title: `Delete the playoff round "${lastRound.name}"?`, content, okText: "Delete",
                        onOk: () => {
                            callWithCatch({
                                url: `/pools/${dp.id}/reset_playoff_round`,
                                method: 'post',
                                onSuccess: () => {
                                    message.success("Round reset!")
                                    window.location.reload();
                                }
                            })
                        }
                    });
                }

                return <Button key="1" onClick={recreate}>Reset Round</Button>
            }

            if (a === "gen_next_round") {
                let gen = async () => {
                    await axios.post(`/pools/${dp.id}/next_playoff_round`);
                    message.success("Generated!");
                    window.location.reload();
                }

                return <XhrBtn key={a} onClick={gen} type="primary">Generate Next Round</XhrBtn>
            }

            return a;
        })}
    </Space>

    let details;
    let status = statusFor(dp.status);

    if (dp.status === "checking_in") {
        let teams = dp.team_ids.map(tid => teamById[tid]);
        let players = _.flatMap(teams, 'players');
        let allCheckedIn = _.every(players, 'checked_in');

        let start = async () => {
            callWithCatch({
                url: `/pools/${dp.id}/start`,
                method: 'post',
                onSuccess: data => {
                    message.success("Started!!");
                    Object.assign(dp, data.pool);
                }
            })
        }

        // singles
        if (teams.length === players.length)
            details = <PlayersCheckinStatus width="200px" players={players} />;
        else {
            let cols;
            let teams4 = teams.length && teams[0].players.length > 2;
            if (teams4 || teams.length > 7)
                cols = "grid-cols-5";
            else
                cols = "grid-cols-8";

            details = <div className={"grid gap-4 " + cols}>
                {teams.map(t => <PlayersCheckinStatus t={t} key={t.id} players={t.players} />)}
            </div>
        }
        actions = []

        if (gon.tournament.printer)
            actions.push(<PoolPrint key="2" id={dp.id} />)

        if (allCheckedIn) {
            actions.push(<XhrBtn key="1" onClick={start} type="primary">Start</XhrBtn>);
            status = <StatusTag message="Ready!" type="success"/>
        }
        else {
            actions.push(<XhrBtn confirm="not everyone checked in, start anyway?" onClick={start}>Start</XhrBtn>)
            status = <StatusTag message="Checking In" />
        }

        actions = <Space>{actions}</Space>
    }

    pp(dp)

    if (dp.status === "playing" || dp.status === "done") {
        if (dp.rounds.length) {
            let cols = "grid-cols-7";
            if (dp.rounds.length > 8 || dp.rounds[0].matches.length > 3)
                cols = "grid-cols-5";
            if (dp.rounds[0].matches.length > 5)
                cols = "grid-cols-4";

            details = <div className={"grid gap-4 " + cols}>
                {dp.rounds.map(r => <FractionProgress noNums key={r.id} steps title={r.name}
                                                      max={r.matches_scores.length} num={_.filter(r.matches_scores)}
                                                      />)}
            </div>
        }
    }

    return <tr>
        <td style={{width: "80px"}}><a onClick={() => NiceModal.show(PoolDrawer, { d, dp })}>{dp.name}</a></td>
        <Showable v={User.admin}>
            <td style={{width: "128px"}}>{status}</td>
            <td>{details}</td>
            <td style={{width: "60px", direction: 'rtl'}}>{actions}</td>
        </Showable>
    </tr>
});

let AdminDivision = observer(({d, onReload}) => {
    let teamById = _.keyBy(d.teams, 'id');

    let actions = d.actions.map(a => {
        if (a === "generate") {
            let schedule = async () => {
                let data = (await axios.put('/divisions/' + d.id, { gen_pools: true })).data;
                if (data.groups)
                    NiceModal.show(PoolsSelector, { division: d, groups: data.groups });
                else {
                    message.success("Matches Generated!");
                    location.reload();
                }
            }

            return <XhrBtn key={a} onClick={schedule} type="primary">Generate Matches</XhrBtn>
        }

        if (a === "ranking")
            return <DivisionRanking key={a} d={d} teamById={teamById} small/>

        if (a === "prelims_result")
            return <PrelimsLeaderboard key={a} teamById={teamById} d={d}/>

        if (a === "custom_print") {
            return null;
            return <Button key={a} size="medium" onClick={() => NiceModal.show(CustomPrint, { d })}>Custom Print</Button>
        }

        if (a === "gen_ranking") {
            let schedule = async () => {
                let data = (await axios.put('/divisions/' + d.id, { gen_ranking: true })).data;
                message.success("Generated!")
                location.reload();
            }

            return <XhrBtn key={a} onClick={schedule} type="primary">Generate Ranking</XhrBtn>
        }

        if (a === "next_playoff_round") {
            let playoff = _.find(d.pools, { knockout: true });
            let nextPlayoffRound = async () => {
                await axios.post(`/pools/${playoff.id}/next_playoff_round`);
                message.success("Generated!")
                location.reload();
            }

            return <XhrBtn keepLoading onClick={nextPlayoffRound} type="primary">Generate Next Round</XhrBtn>
        }

        if (a === "gen_playoff") {
            return <Button type="primary" onClick={() => NiceModal.show(GenPlayoff, {d, teamById})}>Generate Playoff</Button>
        }

        if (a === "create_stage") {
            return <Button type="primary" onClick={() => NiceModal.show(CreateStageModal, {d, onReload})}>Create Stage</Button>
        }

        if (a === "reset_stage") {
            let resetStage = async () => {
                Modal.confirm({
                    title: 'Reset Stage?',
                    content: 'This will delete all pools and matches in the current stage. This action cannot be undone.',
                    okText: 'Reset',
                    okType: 'danger',
                    cancelText: 'Cancel',
                    onOk: async () => {
                        await callWithCatch({
                            url: '/divisions/' + d.id,
                            method: 'put',
                            params: {
                                reset_stage: true,
                                stage: 0
                            },
                            onSuccess: () => {
                                message.success("Stage reset!");
                                onReload();
                            }
                        });
                    }
                });
            };

            return <Button key={a} onClick={resetStage} danger>Reset Stage</Button>
        }

        return a;
    })

    actions = <div><Space>{actions}</Space></div>;

    let title = <div>
        <Space>
            <div>{d.name}</div>
            <div style={{fontSize: "14px"}}><Stats d={d}/></div>
        </Space>
        {Device.xs && actions }
    </div>

    let extra = actions;
    return <Card className="narrow-card" title={title} extra={!Device.xs && actions} style={{marginBottom: "1rem"}} size="large">
        <FakeTable cs="ant-table-small" >
            {d.pools.map(dp => <ErrorBoundary key={dp.id} fallback={<tr><td colSpan={4}>Error loading pool</td></tr>}><AdminPool d={d} dp={dp} /></ErrorBoundary>)}
        </FakeTable>
    </Card>
});


export const MatchSearcher  = observer(({onUpdate}) => {
    let click = e => e.target.select();

    let search = async (mid) => {
        await callWithCatch({
            url: tourneyUrl(`/tmatches/${mid}?mid=${mid}`),
            method: 'get',
            onSuccess: data => {
                NiceModal.show(MatchEditor, { m: observable(data.match), onUpdate });
            }
        })
    }

    return <div className="space-y-2">
        {/*<div style={{paddingLeft: "5px", color: "white"}}>Match id search</div>*/}
        <Input.Search style={{width: "120px"}} autoFocus placeholder="MatchID" onSearch={search} id="goto-mid" onClick={click}/>
    </div>

});


export default observer(({}) => {
    const [store] = useState(() => observable({divs: []}));

    let load = () => {
        pp("loading!")
        // MatchStore.onUpdate = (data) => {
        //     let dd = data.div_info;
        //     _.assign(_.find(store.divs, { id: dd.id}), dd);
        // }

        callWithCatch({
            url: tourneyUrl(`/admin_status`),
            params: {date: mainStore.dateFilter},
            onSuccess: data => {
                pp(data)
                // pp(data.divs[0].pools[0].rounds[0].matches[0])
                store.divs = data.divs;
            },
        })
    }

    useEffect(load, [mainStore.dateFilter]);

    let side = User.admin && !Device.xs && <WithTitle 
        title="Run"
        extra={[
            <Affix key="searcher" offsetTop={0}>
                <div className="p-2 rounded drop-shadow-md" style={{backgroundColor: "#4081F7"}}>
                    <MatchSearcher onUpdate={load} />
                </div>
            </Affix>
        ]}
    />

    return <div className="space-y-4">
        {side}
        {store.divs.map(d => <ErrorBoundary key={d.id} fallback={<div>Error loading division</div>}><AdminDivision d={d} onReload={load}/></ErrorBoundary>)}
        {!store.divs.length && <Skeleton /> }
        {/*<PlayoffMatchEditor />*/}
    </div>
})
